import useModals from 'src/Hooks/useModals'
import { useDeleteInstallation } from 'src/Libs/installation-details/hooks'
import { resetActiveValues } from 'src/State/Storage/StorageActions'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export const useInstallationDeletionDialog = (installationId: number): { openDeleteInstallationConfirmationDialog: () => void } => {
  const { enqueueErrorStack, enqueueSuccessStack } = useSnackbar()
  const { openConfirmationModal } = useModals()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()

  const deleteInstallation = useDeleteInstallation({
    onError: () => enqueueErrorStack(t('installation-configuration.component-list.delete-installation.error')),
    onSuccess: () => {
      navigate('/')
      dispatch(resetActiveValues())
      enqueueSuccessStack(t('installation-configuration.component-list.delete-installation.success'))
    },
  })

  const onConfirmInstallationDeleting = async (): Promise<void> => {
    await deleteInstallation.mutateAsync({
      installationId: installationId,
    })
  }

  const openDeleteInstallationConfirmationDialog = (): void => {
    openConfirmationModal({
      onConfirm: onConfirmInstallationDeleting,
      text: t('installation-configuration.component-list.delete-installation.description'),
      title: t('installation-configuration.component-list.delete-installation.title'),
      buttonText: [t('common.cancel'), t('common.delete')],
    })
  }

  return {
    openDeleteInstallationConfirmationDialog,
  }
}
